<settings-wrapper
  *ngIf="{
    paginationData: paginationData$ | async
  } as STATE"
>
  <page-header />
  <search-bar
    (filterChange)="searchByFilters($event)"
    (search)="searchByName($event)"
    [count]="STATE.paginationData?.fullyItems"
    [searchPlaceholder]="'Rechercher un élément ici'"
    [allowAddButton]="true"
    (add)="openModal()"
    addButtonLabel="Ajouter un utilisateur"
    filterName="administrators"
    countTitle="utilisateurs"
  >
  </search-bar>
  <user-list></user-list>
</settings-wrapper>
